import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
import { PanelTooltipProvider } from "../PanelTooltip/PanelTooltipProvider.js";
function ChartsProvider(props) {
    const { children, chartsTheme, enablePinning = false } = props;
    const ctx = useMemo(()=>({
            chartsTheme,
            enablePinning
        }), [
        chartsTheme,
        enablePinning
    ]);
    return /*#__PURE__*/ jsx(ChartsThemeContext.Provider, {
        value: ctx,
        children: /*#__PURE__*/ jsx(PanelTooltipProvider, {
            children: children
        })
    });
}
const ChartsThemeContext = /*#__PURE__*/ createContext(void 0);
function useChartsContext() {
    const ctx = useContext(ChartsThemeContext);
    if (void 0 === ctx) throw new Error('No ChartsThemeContext found. Did you forget a Provider?');
    return ctx;
}
function useChartsTheme() {
    const ctx = useChartsContext();
    return ctx.chartsTheme;
}
function useContainerPadding() {
    const ctx = useChartsContext();
    return {
        containerPadding: ctx.chartsTheme.container.padding
    };
}
export { ChartsProvider, ChartsThemeContext, useChartsContext, useChartsTheme, useContainerPadding };

//# sourceMappingURL=ChartsProvider.js.map